import { message } from 'antd';

interface MessageFeedbackOptions {
	/** Shared antd message key so a single toast updates in place instead of stacking. */
	key: string;
	loading: string;
	success: string;
	failure: string;
}

// Wrap a non-optimistic write promise in an antd message that transitions
// loading -> success/error. The error is surfaced on the toast (server string when
// available) and swallowed, so a caller's follow-up `.then(refresh)` still runs to
// re-sync from the server.
export const runWithMessageFeedback = (
	promise: Promise<any>,
	{ key, loading, success, failure }: MessageFeedbackOptions
): Promise<any> => {
	message.loading({ content: loading, key });
	return promise
		.then((result) => {
			message.success({ content: success, key, duration: 1.5 });
			return result;
		})
		.catch((error) => {
			message.error({ content: typeof error === 'string' ? error : failure, key });
		});
};
